import { HttpClient } from '@angular/common/http';
import { handleError } from '@app/shared/services/common-function';
import { environment } from '@env/environment';
import { Observable, catchError, map, retry, timeout } from 'rxjs';
import { ApiClientConfig } from '../api-client.config';
import { StorageApiModels } from './api.storage.models';

const STORAGE_FILE_PATH = '/storage/files';

export class StorageApi {
  baseURL = environment.API_URL;

  constructor(
    private http: HttpClient,
    public config: ApiClientConfig
  ) {}

  updateMediaDescription(
    mediaId: string,
    description: string
  ): Observable<StorageApiModels.FileInfo> {
    const body = { description: `${description}` };
    return this.http
      .put<StorageApiModels.FileInfo>(`${this.baseURL}${STORAGE_FILE_PATH}/${mediaId}`, body)
      .pipe(
        timeout(this.config.responseTimeout),
        retry(1),
        map((res: any) => {
          return res;
        }),
        catchError(handleError)
      );
  }

  uploadFile(formData: FormData) {
    return this.http.post<any>(`${this.baseURL}${STORAGE_FILE_PATH}/upload-files`, formData);
  }

  getFile(fileName: string) {
    return this.http.get<string>(`${this.baseURL}${STORAGE_FILE_PATH}/download/${fileName}`);
  }

  downloadFiles(requestBody: StorageApiModels.DownloadRequestBody) {
    this.http
      .post(`${this.baseURL}${STORAGE_FILE_PATH}/download-zip`, requestBody, {
        responseType: 'blob' as 'json'
      })
      .subscribe((res: any) => {
        const file = new Blob([res], { type: 'application/zip' });
        const fileURL = URL.createObjectURL(file);
        let a = document.createElement('a');
        a.href = fileURL;
        a.download = requestBody.name || 'Downloaded files';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(fileURL);
        document.body.removeChild(a);
      });
  }
}
